import { PrivacyPolicy } from '@/components/PrivacyPolicy';

export default PrivacyPolicy;
